import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import classNames from 'classnames'
import './BoardSelector.scss'
import ReactDOM from 'react-dom'

class PortalSelect extends Select {
  updateIfOpen = () => requestAnimationFrame(() => this.state.isOpen && this.forceUpdate())

  componentDidMount() {
    super.componentDidMount()
    window.addEventListener('resize', () => this.updateIfOpen())
  }

  componentWillUnmount() {
    super.componentWillUnmount()
    window.removeEventListener('resize', () => this.updateIfOpen())
  }

  renderOuter(options, valueArray, focusedOption) {
    const dimensions = this.wrapper ? this.wrapper.getBoundingClientRect() : null
    const outer = super.renderOuter(options, valueArray, focusedOption)

    if (!outer || !dimensions) return null

    return ReactDOM.createPortal(
      <div
        ref={ref => { this.menuContainer = ref }}
        className="board-selector"
        onClick={(e) => { e.stopPropagation() }}
        style={{
          zIndex: 9999,
          position: 'absolute',
          width: dimensions.width,
          top: dimensions.top + dimensions.height,
          left: dimensions.left
        }}
      >
        {outer}
      </div>,
      document.body
    )
  }
}

const BoardSelectorOption = (props) => {
  return (
    <div key={props.id} className='board-selector-option'>
      {props.isSelected &&
        (<div className='board-selector-option-select-indicator' />)
      }
      <span className='board-selector-option-title'>{props.name}</span>
      <div className='board-selector-option-lanes'>
        {props.lanes.map(sl => (
          <span key={sl.id} className='board-selector-option-lane'>{sl.name}</span>
        ))}
      </div>
    </div>
  )
}

BoardSelectorOption.propTypes = {
  name: PropTypes.string.isRequired,
  lanes: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired
}

const BoardSelector = (props) => {
  return (
    <div className={classNames({ 'board-selector': true, [props.className]: true })}>
      {Object.keys(props.boardDefs).length > 0 &&
        props.selected !== '' &&
        (<PortalSelect
          options={Object.keys(props.boardDefs).map(k => props.boardDefs[k]).sort((a, b) => a.name.localeCompare(b.name))}
          value={props.selected}
          valueKey='id'
          labelKey='name'
          searchable={false}
          clearable={false}
          onChange={(opt) => props.setSelectedBoard(opt.id)}
          optionRenderer={(opt) => (
            <BoardSelectorOption
              key={opt.id}
              name={opt.name}
              lanes={opt.swimlanes}
              id={opt.id}
              isSelected={opt.id === props.selected}
            />)}
        />)
      }
    </div>
  )
}

BoardSelector.propTypes = {
  boardDefs: PropTypes.object.isRequired,
  selected: PropTypes.string.isRequired,
  setSelectedBoard: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default BoardSelector



// WEBPACK FOOTER //
// ./src/components/BoardSelector/BoardSelector.js